/* -- Generated File: Do Not Edit ------------------------------------------ */
export const textAligns = {
  textAlignLeft: 'left',
  textAlignCenter: 'center',
  textAlignRight: 'right',
};

export default textAligns;
/* -- Generated File: Do Not Edit ------------------------------------------ */
